export const products = [
  {
    sku: 'CH-229A',
    supplierArticle: 'MP-CH229A',
    name: 'High back mesh chair, adjustable headrest, chrome base',
    category: 'chairs',
    source: 'Partner',
    partnerId: 's1',
    partnerName: 'MOON PLUS FURNITURE MANUFACTURING LLC',
    color: 'Black',
    base: 'Chrome',
    stock: 350,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 305,
    discount: 18,
    cost: 250.1,
    sale: 349,
    image:
      'https://readdy.ai/api/search-image?query=Black%20high%20back%20mesh%20office%20chair%20with%20adjustable%20headrest%20and%20polished%20chrome%20base%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-chair-229a&orientation=squarish',
    options: [
      { label: 'Chrome base', surcharge: 28 },
      { label: 'Aluminum base', surcharge: 40 },
      { label: 'Polished armrests', surcharge: 18 },
    ],
    packing: '1 pc / carton',
    cbm: 0.42,
    stockGroup: 'SHJ-MESH-A',
    published: true,
    specialOffer: false,
    description:
      'High back task chair with breathable mesh back, adjustable headrest and 4D armrests. Built for long shifts in project offices and control rooms.',
    specs: [
      { label: 'Back', value: 'Breathable nylon mesh, high back' },
      { label: 'Seat', value: 'Moulded foam, 60 mm, black fabric' },
      { label: 'Mechanism', value: 'Synchro tilt with 3-position lock' },
      { label: 'Gas lift', value: 'Class 4, 100 mm stroke' },
      { label: 'Base', value: 'Chrome 5-star, 320 mm' },
      { label: 'Load rating', value: '130 kg' },
      { label: 'Warranty', value: '3 years structural' },
    ],
    fabrics: [
      { name: 'Black mesh', tone: '#2b2b2b' },
      { name: 'Graphite', tone: '#4b4b4b' },
      { name: 'Slate grey', tone: '#7c8388' },
    ],
    weightKg: 18.5,
    dims: '700 × 680 × 1180',
    unitsPerCarton: 1,
    leadTime: '3–5 working days',
    origin: 'China',
    incoterm: 'DDP Dubai',
    hsCode: '9401.30',
    minOrder: 5,
  },
  {
    sku: 'EVL-004B',
    supplierArticle: 'EV-CH004B',
    name: 'White frame grey mesh chair',
    category: 'chairs',
    source: 'Partner',
    partnerId: 's12',
    partnerName: 'EVEREST FURNITURES TRADING LLC.',
    color: 'Grey',
    base: 'White nylon',
    stock: 438,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 535,
    discount: 10,
    cost: 481.5,
    sale: 675,
    image:
      'https://readdy.ai/api/search-image?query=Grey%20mesh%20conference%20chair%20with%20white%20nylon%20frame%20and%20five%20star%20base%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-chair-evl004b&orientation=squarish',
    options: [
      { label: 'White nylon base', surcharge: 0 },
      { label: 'Chrome base', surcharge: 32 },
    ],
    packing: '1 pc / carton',
    cbm: 0.38,
    stockGroup: 'RKH-MESH-B',
    published: true,
    specialOffer: false,
    description:
      'Light, clean meeting chair with white frame detailing. Specified for boardrooms and client-facing meeting rooms where visual weight matters.',
    specs: [
      { label: 'Back', value: 'Grey mesh, mid back' },
      { label: 'Seat', value: 'Foam with grey knit upholstery' },
      { label: 'Mechanism', value: 'Fixed tilt, lockable' },
      { label: 'Base', value: 'White nylon 5-star' },
      { label: 'Load rating', value: '120 kg' },
      { label: 'Warranty', value: '2 years structural' },
    ],
    fabrics: [
      { name: 'Grey mesh', tone: '#8b9096' },
      { name: 'Light grey', tone: '#b6b9bc' },
      { name: 'Charcoal', tone: '#4a4d50' },
    ],
    weightKg: 15.2,
    dims: '640 × 620 × 1010',
    unitsPerCarton: 1,
    leadTime: '2–4 working days',
    origin: 'China',
    incoterm: 'DDP Dubai',
    hsCode: '9401.30',
    minOrder: 10,
  },
  {
    sku: 'CH-601A',
    supplierArticle: 'OT-601A',
    name: 'Ergonomic mesh chair, 4-position synchro tilt',
    category: 'chairs',
    source: 'Partner',
    partnerId: 's3',
    partnerName: 'Ottimo Office Furtniture Factory L.L.C',
    color: 'Black',
    base: 'Black nylon',
    stock: 100,
    incomingQty: 130,
    incomingEta: '2026-11-05',
    partnerPrice: 522,
    discount: 22,
    cost: 407.16,
    sale: 570,
    image:
      'https://readdy.ai/api/search-image?query=Ergonomic%20black%20mesh%20office%20chair%20with%20lumbar%20support%20and%20black%20nylon%20base%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-chair-601a&orientation=squarish',
    options: [
      { label: 'Black nylon base', surcharge: 0 },
      { label: 'Aluminum base', surcharge: 40 },
      { label: 'Headrest', surcharge: 55 },
    ],
    packing: '1 pc / carton',
    cbm: 0.4,
    stockGroup: 'AJM-MESH-C',
    published: false,
    specialOffer: false,
    description:
      'Task chair with 4-position synchro tilt and adjustable lumbar. Popular for full-floor fit-outs with long sitting hours.',
    specs: [
      { label: 'Back', value: 'Mesh with adjustable lumbar pad' },
      { label: 'Seat', value: 'High density foam, 65 mm' },
      { label: 'Mechanism', value: 'Synchro tilt, 4-position lock' },
      { label: 'Base', value: 'Black nylon 5-star' },
      { label: 'Load rating', value: '125 kg' },
      { label: 'Warranty', value: '3 years structural' },
    ],
    fabrics: [
      { name: 'Black mesh', tone: '#2b2b2b' },
      { name: 'Grey mesh', tone: '#8b9096' },
    ],
    weightKg: 19.4,
    dims: '690 × 660 × 1150',
    unitsPerCarton: 1,
    leadTime: '10–14 working days',
    origin: 'Italy / China',
    incoterm: 'DAP UAE',
    hsCode: '9401.30',
    minOrder: 10,
  },
  {
    sku: 'HY-128C',
    supplierArticle: 'SH-HY128C',
    name: 'Training chair with writing pad, folding',
    category: 'chairs',
    source: 'Partner',
    partnerId: 's4',
    partnerName: 'AL SEHAM FURNITURE L.L.C',
    color: 'Blue',
    base: 'Black steel',
    stock: 700,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 205,
    discount: 0,
    cost: 205,
    sale: 279,
    image:
      'https://readdy.ai/api/search-image?query=Blue%20training%20chair%20with%20foldable%20writing%20tablet%20and%20black%20steel%20frame%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-chair-hy128c&orientation=squarish',
    options: [
      { label: 'Writing tablet right', surcharge: 0 },
      { label: 'Writing tablet left', surcharge: 0 },
      { label: 'Ganging kit', surcharge: 22 },
    ],
    packing: '4 pcs / carton',
    cbm: 0.12,
    stockGroup: 'DXB-TRAIN-A',
    published: true,
    specialOffer: true,
    description:
      'Special offer item with no dealer discount applied. Folding training chair with tablet arm, specified for training rooms and seminar floors.',
    specs: [
      { label: 'Seat / back', value: 'Moulded polypropylene, blue' },
      { label: 'Tablet', value: 'Foldable PP tablet, right hand' },
      { label: 'Frame', value: 'Black powder coated steel' },
      { label: 'Stacking', value: 'Up to 12 units' },
      { label: 'Load rating', value: '110 kg' },
      { label: 'Warranty', value: '2 years' },
    ],
    fabrics: [
      { name: 'Blue', tone: '#3f6478' },
      { name: 'Black', tone: '#2b2b2b' },
      { name: 'Grey', tone: '#8b9096' },
    ],
    weightKg: 8.6,
    dims: '580 × 540 × 860',
    unitsPerCarton: 4,
    leadTime: '4–6 working days',
    origin: 'China',
    incoterm: 'DDP Dubai',
    hsCode: '9401.71',
    minOrder: 20,
  },
  {
    sku: 'ML-120M',
    supplierArticle: 'BK-LEG120M',
    name: 'Table middle leg 120 cm, black/white',
    category: 'components',
    source: 'Partner',
    partnerId: 's2',
    partnerName: 'BARAKAT ALSAHRA TECHNICAL SERVICES LLC.',
    color: 'Black',
    base: 'Steel',
    stock: 826,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 198,
    discount: 16,
    cost: 166.32,
    sale: 235,
    image:
      'https://readdy.ai/api/search-image?query=Black%20powder%20coated%20steel%20table%20middle%20leg%20component%20120%20cm%20with%20adjustable%20foot%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-leg-ml120m&orientation=squarish',
    options: [
      { label: 'Black', surcharge: 0 },
      { label: 'White', surcharge: 0 },
      { label: 'Height adjustable foot', surcharge: 15 },
    ],
    packing: '1 pc / carton',
    cbm: 0.06,
    stockGroup: 'SHJ-LEG-A',
    published: true,
    specialOffer: false,
    description:
      'Middle leg for 120 cm deep meeting tables. Used to complete long table runs from own frames plus partner components.',
    specs: [
      { label: 'Height', value: '720 mm fixed' },
      { label: 'Tube', value: '60 × 60 mm steel, 1.5 mm' },
      { label: 'Finish', value: 'Powder coated, matte' },
      { label: 'Foot', value: 'Adjustable ±10 mm' },
      { label: 'Warranty', value: '5 years' },
    ],
    fabrics: [
      { name: 'Black', tone: '#2b2b2b' },
      { name: 'White', tone: '#e8e8e4' },
    ],
    weightKg: 4.2,
    dims: '120 × 60 × 720',
    unitsPerCarton: 1,
    leadTime: '5–7 working days',
    origin: 'UAE',
    incoterm: 'EXW Sharjah',
    hsCode: '7308.90',
    minOrder: 10,
  },
  {
    sku: 'CH-527A',
    supplierArticle: 'FW-527A',
    name: 'Black PU executive chair',
    category: 'chairs',
    source: 'Partner',
    partnerId: 's8',
    partnerName: 'FUTURE WORKPLACE OFFICE FURNITURE TRADING CO LLC',
    color: 'Black',
    base: 'Chrome',
    stock: 0,
    incomingQty: 73,
    incomingEta: '2026-11-03',
    partnerPrice: 435,
    discount: 19,
    cost: 352.35,
    sale: 495,
    image:
      'https://readdy.ai/api/search-image?query=Black%20PU%20leather%20executive%20office%20chair%20with%20chrome%20base%20and%20padded%20armrests%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-chair-527a&orientation=squarish',
    options: [
      { label: 'Chrome base', surcharge: 0 },
      { label: 'Aluminum base', surcharge: 40 },
    ],
    packing: '1 pc / carton',
    cbm: 0.45,
    stockGroup: 'DIP-PU-A',
    published: true,
    specialOffer: false,
    description:
      'Executive chair in black PU with high resilience foam. Currently out of stock, inbound shipment confirmed for early November.',
    specs: [
      { label: 'Upholstery', value: 'Black PU leather' },
      { label: 'Back', value: 'High back with lumbar curve' },
      { label: 'Mechanism', value: 'Multi-lock tilt' },
      { label: 'Base', value: 'Chrome 5-star, 350 mm' },
      { label: 'Load rating', value: '135 kg' },
      { label: 'Warranty', value: '3 years structural' },
    ],
    fabrics: [
      { name: 'Black PU', tone: '#232323' },
      { name: 'Espresso PU', tone: '#4a3527' },
    ],
    weightKg: 22.8,
    dims: '720 × 700 × 1220',
    unitsPerCarton: 1,
    leadTime: '4–6 working days',
    origin: 'China',
    incoterm: 'DDP Dubai',
    hsCode: '9401.30',
    minOrder: 5,
  },
  {
    sku: 'CH-880B',
    supplierArticle: 'TRJ-880B',
    name: 'Mesh task chair with lumbar support, black',
    category: 'chairs',
    source: 'Own',
    partnerId: null,
    partnerName: 'Treejar warehouse',
    color: 'Black',
    base: 'Black nylon',
    stock: 124,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 210,
    discount: 0,
    cost: 210,
    sale: 315,
    image:
      'https://readdy.ai/api/search-image?query=Black%20mesh%20task%20chair%20with%20adjustable%20lumbar%20support%20and%20black%20nylon%20base%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-chair-880b&orientation=squarish',
    options: [
      { label: 'Black nylon base', surcharge: 0 },
      { label: 'Chrome base', surcharge: 30 },
    ],
    packing: '1 pc / carton',
    cbm: 0.4,
    stockGroup: 'TRJ-OWN-MESH',
    published: true,
    specialOffer: false,
    description:
      'Treejar own-stock task chair. Used as the default budget option in office fit-outs where lead time matters more than finish.',
    specs: [
      { label: 'Back', value: 'Mesh, mid back' },
      { label: 'Seat', value: 'Foam with black fabric' },
      { label: 'Mechanism', value: 'Tilt with tension adjust' },
      { label: 'Base', value: 'Black nylon 5-star' },
      { label: 'Warranty', value: '2 years' },
    ],
    fabrics: [
      { name: 'Black', tone: '#2b2b2b' },
      { name: 'Grey', tone: '#8b9096' },
    ],
    weightKg: 16.4,
    dims: '660 × 640 × 1080',
    unitsPerCarton: 1,
    leadTime: 'Immediate from stock',
    origin: 'China',
    incoterm: 'DDP Dubai',
    hsCode: '9401.30',
    minOrder: 1,
  },
  {
    sku: 'ST-410',
    supplierArticle: 'TRJ-410',
    name: 'Height adjustable desk frame 120-160 cm',
    category: 'workstations',
    source: 'Own',
    partnerId: null,
    partnerName: 'Treejar warehouse',
    color: 'White',
    base: 'Steel',
    stock: 86,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 640,
    discount: 0,
    cost: 640,
    sale: 895,
    image:
      'https://readdy.ai/api/search-image?query=White%20electric%20height%20adjustable%20desk%20frame%20with%20dual%20motors%20and%20steel%20legs%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-frame-st410&orientation=squarish',
    options: [
      { label: 'White frame', surcharge: 0 },
      { label: 'Black frame', surcharge: 0 },
      { label: 'Cable tray', surcharge: 65 },
    ],
    packing: '1 set / 2 cartons',
    cbm: 0.18,
    stockGroup: 'TRJ-OWN-FRAME',
    published: true,
    specialOffer: false,
    description:
      'Dual-motor sit-stand frame with memory presets, sold as frame only. Tops are sourced from partner stock to match specification.',
    specs: [
      { label: 'Range', value: '620 – 1270 mm' },
      { label: 'Motors', value: 'Dual, 1000 N each' },
      { label: 'Presets', value: '4 memory + anti-collision' },
      { label: 'Load', value: '120 kg' },
      { label: 'Warranty', value: '5 years' },
    ],
    fabrics: [
      { name: 'White', tone: '#e8e8e4' },
      { name: 'Black', tone: '#2b2b2b' },
    ],
    weightKg: 32.5,
    dims: '1600 × 700 × 620',
    unitsPerCarton: 1,
    leadTime: 'Immediate from stock',
    origin: 'China',
    incoterm: 'DDP Dubai',
    hsCode: '9403.10',
    minOrder: 1,
  },
  {
    sku: 'CT-220',
    supplierArticle: 'OFT-CT220',
    name: 'Coffee table stand, round chrome',
    category: 'coffeeTables',
    source: 'Partner',
    partnerId: 's5',
    partnerName: 'OFFICE TOUCH FURNITURE INDUSTRY LLC.',
    color: 'Chrome',
    base: 'Chrome',
    stock: 412,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 145,
    discount: 14,
    cost: 124.7,
    sale: 175,
    image:
      'https://readdy.ai/api/search-image?query=Round%20polished%20chrome%20coffee%20table%20base%20stand%20with%20flat%20cross%20feet%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-stand-ct220&orientation=squarish',
    options: [
      { label: 'Chrome', surcharge: 0 },
      { label: 'Matte black', surcharge: 12 },
    ],
    packing: '2 pcs / carton',
    cbm: 0.05,
    stockGroup: 'SHJ-STAND-A',
    published: false,
    specialOffer: false,
    description: 'Round coffee table base for lounge and reception areas. Pairs with 800 mm glass or HPL tops.',
    specs: [
      { label: 'Diameter', value: '500 mm' },
      { label: 'Height', value: '420 mm' },
      { label: 'Finish', value: 'Polished chrome' },
      { label: 'Warranty', value: '2 years' },
    ],
    fabrics: [
      { name: 'Chrome', tone: '#b9bec2' },
      { name: 'Matte black', tone: '#2b2b2b' },
    ],
    weightKg: 6.8,
    dims: '500 × 500 × 420',
    unitsPerCarton: 2,
    leadTime: '6–8 working days',
    origin: 'China',
    incoterm: 'EXW Sharjah',
    hsCode: '9403.20',
    minOrder: 4,
  },
  {
    sku: 'PU-115',
    supplierArticle: 'SKY-S115',
    name: 'Guest sofa 2-seater, grey fabric',
    category: 'softSeating',
    source: 'Partner',
    partnerId: 's9',
    partnerName: 'SKY OFFICE FURNITURE MANUFACTURING LLC',
    color: 'Grey',
    base: 'Timber',
    stock: 58,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 890,
    discount: 13,
    cost: 774.3,
    sale: 1085,
    image:
      'https://readdy.ai/api/search-image?query=Two%20seater%20grey%20fabric%20guest%20sofa%20with%20low%20profile%20arms%20and%20timber%20legs%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-sofa-pu115&orientation=squarish',
    options: [
      { label: 'Grey fabric', surcharge: 0 },
      { label: 'Navy fabric', surcharge: 45 },
      { label: 'Stain guard treatment', surcharge: 90 },
    ],
    packing: '1 pc / carton',
    cbm: 1.15,
    stockGroup: 'AJM-SOFA-A',
    published: false,
    specialOffer: false,
    description:
      'Reception sofa with contract-grade fabric, made locally in Ajman. Re-upholstery is possible on repeat orders.',
    specs: [
      { label: 'Upholstery', value: 'Contract polyester, 40k Martindale' },
      { label: 'Frame', value: 'Kiln dried hardwood' },
      { label: 'Legs', value: 'Solid timber, walnut finish' },
      { label: 'Dimensions', value: 'W 1580 × D 760 × H 760 mm' },
      { label: 'Warranty', value: '3 years' },
    ],
    fabrics: [
      { name: 'Grey', tone: '#8b9096' },
      { name: 'Navy', tone: '#2f3d4a' },
      { name: 'Sand', tone: '#c2b49c' },
    ],
    weightKg: 42,
    dims: '1580 × 760 × 760',
    unitsPerCarton: 1,
    leadTime: '12–16 working days',
    origin: 'UAE',
    incoterm: 'DAP UAE',
    hsCode: '9401.61',
    minOrder: 2,
  },
  {
    sku: 'TR-305',
    supplierArticle: 'MP-TR305',
    name: 'Training table, flip-top, white',
    category: 'meetingTables',
    source: 'Partner',
    partnerId: 's1',
    partnerName: 'MOON PLUS FURNITURE MANUFACTURING LLC',
    color: 'White',
    base: 'Steel',
    stock: 210,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 318,
    discount: 18,
    cost: 260.76,
    sale: 365,
    image:
      'https://readdy.ai/api/search-image?query=White%20flip%20top%20training%20table%20with%20folding%20steel%20legs%20and%20castors%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-table-tr305&orientation=squarish',
    options: [
      { label: 'Castors', surcharge: 0 },
      { label: 'Ganging link', surcharge: 25 },
    ],
    packing: '1 pc / carton',
    cbm: 0.22,
    stockGroup: 'DXB-TABLE-A',
    published: true,
    specialOffer: false,
    description: 'Flip-top training table that nests for storage. Standard for seminar rooms and temporary project offices.',
    specs: [
      { label: 'Top', value: '25 mm HPL, white' },
      { label: 'Size', value: 'W 1400 × D 500 × H 750 mm' },
      { label: 'Frame', value: 'Steel, powder coated' },
      { label: 'Mobility', value: 'Castors with brake' },
      { label: 'Warranty', value: '3 years' },
    ],
    fabrics: [
      { name: 'White top', tone: '#e8e8e4' },
      { name: 'Oak top', tone: '#c2a878' },
    ],
    weightKg: 21.5,
    dims: '1400 × 500 × 750',
    unitsPerCarton: 1,
    leadTime: '3–5 working days',
    origin: 'China',
    incoterm: 'DDP Dubai',
    hsCode: '9403.10',
    minOrder: 6,
  },
  {
    sku: 'ML-090',
    supplierArticle: 'BK-LEG090',
    name: 'Table leg 90 cm, black',
    category: 'components',
    source: 'Partner',
    partnerId: 's2',
    partnerName: 'BARAKAT ALSAHRA TECHNICAL SERVICES LLC.',
    color: 'Black',
    base: 'Steel',
    stock: 0,
    incomingQty: 120,
    incomingEta: '2026-11-13',
    partnerPrice: 172,
    discount: 16,
    cost: 144.48,
    sale: 205,
    image:
      'https://readdy.ai/api/search-image?query=Black%20powder%20coated%20steel%20table%20leg%2090%20cm%20with%20top%20plate%20and%20adjustable%20glide%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-leg-ml090&orientation=squarish',
    options: [
      { label: 'Black', surcharge: 0 },
      { label: 'White', surcharge: 0 },
    ],
    packing: '2 pcs / carton',
    cbm: 0.04,
    stockGroup: 'SHJ-LEG-A',
    published: true,
    specialOffer: false,
    description: 'Standard 90 cm table leg shared with the 120 cm middle leg stock pool. Inbound shipment mid November.',
    specs: [
      { label: 'Height', value: '720 mm' },
      { label: 'Tube', value: '50 × 50 mm steel' },
      { label: 'Finish', value: 'Powder coated, matte' },
      { label: 'Warranty', value: '5 years' },
    ],
    fabrics: [
      { name: 'Black', tone: '#2b2b2b' },
      { name: 'White', tone: '#e8e8e4' },
    ],
    weightKg: 3.1,
    dims: '90 × 50 × 720',
    unitsPerCarton: 2,
    leadTime: '5–7 working days',
    origin: 'UAE',
    incoterm: 'EXW Sharjah',
    hsCode: '7308.90',
    minOrder: 10,
  },
  {
    sku: 'CH-410',
    supplierArticle: 'EV-V410',
    name: 'Mesh visitor chair, 4-leg',
    category: 'chairs',
    source: 'Partner',
    partnerId: 's12',
    partnerName: 'EVEREST FURNITURES TRADING LLC.',
    color: 'Black',
    base: 'Chrome',
    stock: 264,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 268,
    discount: 10,
    cost: 241.2,
    sale: 339,
    image:
      'https://readdy.ai/api/search-image?query=Black%20mesh%20visitor%20chair%20on%20four%20leg%20chrome%20frame%20with%20padded%20seat%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-chair-410&orientation=squarish',
    options: [
      { label: 'Chrome frame', surcharge: 0 },
      { label: 'Black frame', surcharge: 0 },
      { label: 'Stacking skid', surcharge: 18 },
    ],
    packing: '4 pcs / carton',
    cbm: 0.14,
    stockGroup: 'RKH-MESH-B',
    published: true,
    specialOffer: false,
    description: 'Stackable visitor chair for meeting rooms and waiting areas. Shares stock pool with the EVL-004B range.',
    specs: [
      { label: 'Back', value: 'Black mesh, low back' },
      { label: 'Seat', value: 'Padded, black fabric' },
      { label: 'Frame', value: 'Chrome 4-leg' },
      { label: 'Stacking', value: 'Up to 6 units' },
      { label: 'Warranty', value: '2 years' },
    ],
    fabrics: [
      { name: 'Black', tone: '#2b2b2b' },
      { name: 'Grey', tone: '#8b9096' },
    ],
    weightKg: 9.8,
    dims: '560 × 540 × 890',
    unitsPerCarton: 4,
    leadTime: '2–4 working days',
    origin: 'China',
    incoterm: 'DDP Dubai',
    hsCode: '9401.30',
    minOrder: 8,
  },
  {
    sku: 'PU-208',
    supplierArticle: 'FW-208',
    name: 'Executive high-back PU chair with headrest',
    category: 'softSeating',
    source: 'Partner',
    partnerId: 's8',
    partnerName: 'FUTURE WORKPLACE OFFICE FURNITURE TRADING CO LLC',
    color: 'Black',
    base: 'Chrome',
    stock: 0,
    incomingQty: 40,
    incomingEta: '2026-11-06',
    partnerPrice: 610,
    discount: 19,
    cost: 494.1,
    sale: 695,
    image:
      'https://readdy.ai/api/search-image?query=Black%20PU%20high%20back%20executive%20chair%20with%20integrated%20headrest%20and%20wide%20chrome%20base%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-chair-208&orientation=squarish',
    options: [
      { label: 'Chrome base', surcharge: 0 },
      { label: 'Aluminum base', surcharge: 40 },
      { label: 'Knee-tilt mechanism', surcharge: 75 },
    ],
    packing: '1 pc / carton',
    cbm: 0.48,
    stockGroup: 'DIP-PU-B',
    published: false,
    specialOffer: false,
    description: 'Directors-level PU chair with integrated headrest. Awaiting inbound stock before it can go live on the storefront.',
    specs: [
      { label: 'Upholstery', value: 'Black PU, perforated back' },
      { label: 'Back', value: 'High back with headrest' },
      { label: 'Mechanism', value: 'Multi-lock with knee tilt' },
      { label: 'Base', value: 'Chrome 5-star, 350 mm' },
      { label: 'Warranty', value: '3 years' },
    ],
    fabrics: [
      { name: 'Black PU', tone: '#232323' },
      { name: 'Espresso PU', tone: '#4a3527' },
    ],
    weightKg: 24.6,
    dims: '760 × 720 × 1250',
    unitsPerCarton: 1,
    leadTime: '4–6 working days',
    origin: 'China',
    incoterm: 'DDP Dubai',
    hsCode: '9401.30',
    minOrder: 4,
  },
  {
    sku: 'WS-150',
    supplierArticle: 'MP-WS150',
    name: 'Workstation cluster, 4 places, 1600 mm',
    category: 'workstations',
    source: 'Partner',
    partnerId: 's1',
    partnerName: 'MOON PLUS FURNITURE MANUFACTURING LLC',
    color: 'Grey',
    base: 'Steel',
    stock: 42,
    incomingQty: 20,
    incomingEta: '2026-11-09',
    partnerPrice: 1850,
    discount: 18,
    cost: 1517,
    sale: 2125,
    image:
      'https://readdy.ai/api/search-image?query=Four%20person%20office%20workstation%20cluster%20with%20grey%20acoustic%20dividers%20and%20white%20laminate%20tops%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-workstation-ws150&orientation=squarish',
    options: [
      { label: 'Grey dividers', surcharge: 0 },
      { label: 'Fabric screens', surcharge: 180 },
      { label: 'Cable management', surcharge: 95 },
    ],
    packing: '1 set / 6 cartons',
    cbm: 1.85,
    stockGroup: 'DXB-WS-A',
    published: true,
    specialOffer: false,
    description:
      'Four-place bench workstation with acoustic dividers and integrated cable trays. The backbone of most Treejar floor fit-outs.',
    specs: [
      { label: 'Top', value: '25 mm melamine, light grey' },
      { label: 'Size', value: 'W 3200 × D 1600 × H 1200 mm' },
      { label: 'Dividers', value: 'PET acoustic panel, 30 mm' },
      { label: 'Frame', value: 'Powder coated steel' },
      { label: 'Warranty', value: '5 years' },
    ],
    fabrics: [
      { name: 'Light grey', tone: '#b6b9bc' },
      { name: 'Graphite', tone: '#4b4b4b' },
    ],
    weightKg: 96,
    dims: '3200 × 1600 × 1200',
    unitsPerCarton: 1,
    leadTime: '3–5 working days',
    origin: 'UAE',
    incoterm: 'DDP Dubai',
    hsCode: '9403.30',
    minOrder: 2,
  },
  {
    sku: 'DS-180',
    supplierArticle: 'MP-DS180',
    name: 'Executive desk 180 × 90 cm, walnut veneer',
    category: 'execDesks',
    source: 'Partner',
    partnerId: 's1',
    partnerName: 'MOON PLUS FURNITURE MANUFACTURING LLC',
    color: 'Walnut',
    base: 'Panel',
    stock: 26,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 1480,
    discount: 18,
    cost: 1213.6,
    sale: 1700,
    image:
      'https://readdy.ai/api/search-image?query=Walnut%20veneer%20executive%20desk%20180%20cm%20with%20modesty%20panel%20and%20brushed%20metal%20legs%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-desk-ds180&orientation=squarish',
    options: [
      { label: 'Walnut veneer', surcharge: 0 },
      { label: 'Oak veneer', surcharge: 0 },
      { label: 'Leather inlay top', surcharge: 240 },
    ],
    packing: '1 pc / crate',
    cbm: 1.2,
    stockGroup: 'DXB-EXEC-A',
    published: true,
    specialOffer: false,
    description:
      'Directors desk with walnut veneer top and cable port. Usually specified together with the PU-208 chair for executive rooms.',
    specs: [
      { label: 'Top', value: 'Walnut veneer on MDF, 30 mm' },
      { label: 'Size', value: 'W 1800 × D 900 × H 750 mm' },
      { label: 'Legs', value: 'Brushed metal, panel ends' },
      { label: 'Cable port', value: 'Flip-top, 2 modules' },
      { label: 'Warranty', value: '5 years' },
    ],
    fabrics: [
      { name: 'Walnut', tone: '#6b4a33' },
      { name: 'Oak', tone: '#c2a878' },
    ],
    weightKg: 78,
    dims: '1800 × 900 × 750',
    unitsPerCarton: 1,
    leadTime: '3–5 working days',
    origin: 'UAE',
    incoterm: 'DDP Dubai',
    hsCode: '9403.30',
    minOrder: 1,
  },
  {
    sku: 'SC-200',
    supplierArticle: 'SC-C200',
    name: 'Storage cabinet 4 doors, 1800 mm',
    category: 'storage',
    source: 'Partner',
    partnerId: 's10',
    partnerName: 'SOLO CLASS GENERAL TRADING LLC',
    color: 'Grey',
    base: 'Steel',
    stock: 137,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 890,
    discount: 21,
    cost: 703.1,
    sale: 985,
    image:
      'https://readdy.ai/api/search-image?query=Grey%20steel%20office%20storage%20cabinet%20with%20four%20doors%20and%20adjustable%20shelves%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-cabinet-sc200&orientation=squarish',
    options: [
      { label: 'Grey', surcharge: 0 },
      { label: 'White', surcharge: 0 },
      { label: 'Lock with master key', surcharge: 45 },
    ],
    packing: '1 pc / crate',
    cbm: 0.95,
    stockGroup: 'SHJ-STOR-A',
    published: true,
    specialOffer: false,
    description:
      'Four-door steel cabinet with adjustable shelving and full-length doors. Deepest storage stock in the network.',
    specs: [
      { label: 'Body', value: '0.8 mm cold rolled steel' },
      { label: 'Size', value: 'W 1600 × D 450 × H 1800 mm' },
      { label: 'Shelves', value: '4 adjustable per bay' },
      { label: 'Finish', value: 'Powder coated, grey RAL 7035' },
      { label: 'Warranty', value: '5 years' },
    ],
    fabrics: [
      { name: 'Grey', tone: '#8b9096' },
      { name: 'White', tone: '#e8e8e4' },
    ],
    weightKg: 62,
    dims: '1600 × 450 × 1800',
    unitsPerCarton: 1,
    leadTime: '6–9 working days',
    origin: 'UAE',
    incoterm: 'EXW Sharjah',
    hsCode: '9403.10',
    minOrder: 2,
  },
  {
    sku: 'PD-045',
    supplierArticle: 'SC-P045',
    name: 'Mobile pedestal, 3 drawers',
    category: 'pedestals',
    source: 'Partner',
    partnerId: 's10',
    partnerName: 'SOLO CLASS GENERAL TRADING LLC',
    color: 'Grey',
    base: 'Steel',
    stock: 304,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 210,
    discount: 21,
    cost: 165.9,
    sale: 235,
    image:
      'https://readdy.ai/api/search-image?query=Grey%20steel%20mobile%20pedestal%20with%20three%20drawers%20and%20castors%20under%20office%20desk%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-pedestal-pd045&orientation=squarish',
    options: [
      { label: 'Grey', surcharge: 0 },
      { label: 'White', surcharge: 0 },
      { label: 'Central lock', surcharge: 28 },
    ],
    packing: '1 pc / carton',
    cbm: 0.16,
    stockGroup: 'SHJ-STOR-A',
    published: true,
    specialOffer: false,
    description: 'Three-drawer mobile pedestal with castors and central lock option. Shared stock pool with the SC-200 cabinet range.',
    specs: [
      { label: 'Size', value: 'W 420 × D 520 × H 600 mm' },
      { label: 'Drawers', value: '2 box + 1 file' },
      { label: 'Mobility', value: '4 castors, 2 braked' },
      { label: 'Warranty', value: '5 years' },
    ],
    fabrics: [
      { name: 'Grey', tone: '#8b9096' },
      { name: 'White', tone: '#e8e8e4' },
    ],
    weightKg: 18,
    dims: '420 × 520 × 600',
    unitsPerCarton: 1,
    leadTime: '6–9 working days',
    origin: 'UAE',
    incoterm: 'EXW Sharjah',
    hsCode: '9403.10',
    minOrder: 4,
  },
  {
    sku: 'PT-160',
    supplierArticle: 'BK-PT160',
    name: 'Acoustic desk screen 160 × 160, grey',
    category: 'partitions',
    source: 'Partner',
    partnerId: 's2',
    partnerName: 'BARAKAT ALSAHRA TECHNICAL SERVICES LLC.',
    color: 'Grey',
    base: 'Aluminium',
    stock: 188,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 305,
    discount: 16,
    cost: 256.2,
    sale: 359,
    image:
      'https://readdy.ai/api/search-image?query=Grey%20acoustic%20felt%20desk%20screen%20160%20cm%20with%20aluminium%20trim%20and%20clamp%20mounts%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-screen-pt160&orientation=squarish',
    options: [
      { label: 'Clamp mount', surcharge: 0 },
      { label: 'Free-standing feet', surcharge: 55 },
      { label: 'Fabric finish', surcharge: 40 },
    ],
    packing: '1 pc / crate',
    cbm: 0.09,
    stockGroup: 'SHJ-PART-A',
    published: false,
    specialOffer: false,
    description:
      'PET acoustic screen for desk-mounted privacy. Specified with workstations in open-plan floors to control noise.',
    specs: [
      { label: 'Panel', value: 'PET felt, 12 mm, 60% recycled' },
      { label: 'Size', value: 'W 1600 × H 1600 mm' },
      { label: 'Trim', value: 'Anodised aluminium' },
      { label: 'NRC', value: '0.65' },
      { label: 'Warranty', value: '3 years' },
    ],
    fabrics: [
      { name: 'Grey', tone: '#8b9096' },
      { name: 'Sand', tone: '#c2b49c' },
    ],
    weightKg: 12,
    dims: '1600 × 40 × 1600',
    unitsPerCarton: 1,
    leadTime: '5–7 working days',
    origin: 'UAE',
    incoterm: 'EXW Sharjah',
    hsCode: '9403.90',
    minOrder: 4,
  },
  {
    sku: 'RC-240',
    supplierArticle: 'MP-RC240',
    name: 'Reception counter 240 cm, white and oak',
    category: 'reception',
    source: 'Partner',
    partnerId: 's1',
    partnerName: 'MOON PLUS FURNITURE MANUFACTURING LLC',
    color: 'White',
    base: 'Panel',
    stock: 7,
    incomingQty: 4,
    incomingEta: '2026-11-16',
    partnerPrice: 2450,
    discount: 18,
    cost: 2009,
    sale: 2815,
    image:
      'https://readdy.ai/api/search-image?query=Modern%20reception%20counter%20240%20cm%20with%20white%20body%20and%20oak%20front%20panel%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-reception-rc240&orientation=squarish',
    options: [
      { label: 'Oak front panel', surcharge: 0 },
      { label: 'LED underlight', surcharge: 190 },
      { label: 'Transaction top', surcharge: 120 },
    ],
    packing: '1 pc / crate + top',
    cbm: 2.1,
    stockGroup: 'DXB-RECEP-A',
    published: false,
    specialOffer: false,
    description:
      'Reception counter with oak front panel and concealed cable management. Made to order in Dubai, small buffer stock held.',
    specs: [
      { label: 'Body', value: 'MDF with white lacquer' },
      { label: 'Front', value: 'Oak veneer slats' },
      { label: 'Size', value: 'W 2400 × D 800 × H 1100 mm' },
      { label: 'Worktop', value: 'Solid surface, 20 mm' },
      { label: 'Warranty', value: '5 years' },
    ],
    fabrics: [
      { name: 'White / oak', tone: '#c2a878' },
      { name: 'Graphite / oak', tone: '#4b4b4b' },
    ],
    weightKg: 110,
    dims: '2400 × 800 × 1100',
    unitsPerCarton: 1,
    leadTime: '3–5 working days',
    origin: 'UAE',
    incoterm: 'DDP Dubai',
    hsCode: '9403.60',
    minOrder: 1,
  },
  {
    sku: 'CT-300',
    supplierArticle: 'CW-CT300',
    name: 'Nesting coffee table, round 600 mm',
    category: 'coffeeTables',
    source: 'Partner',
    partnerId: 's11',
    partnerName: 'CATCH WORD FURNITURE FZCO',
    color: 'Oak',
    base: 'Timber',
    stock: 64,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 240,
    discount: 12,
    cost: 211.2,
    sale: 295,
    image:
      'https://readdy.ai/api/search-image?query=Round%20oak%20nesting%20coffee%20table%20600%20mm%20with%20slim%20timber%20legs%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-table-ct300&orientation=squarish',
    options: [
      { label: 'Oak', surcharge: 0 },
      { label: 'Walnut', surcharge: 20 },
    ],
    packing: '3 pcs / carton',
    cbm: 0.12,
    stockGroup: 'DSO-LOUNGE-A',
    published: true,
    specialOffer: false,
    description: 'Nesting lounge table for waiting areas and breakout zones. Packs three per carton to keep freight low.',
    specs: [
      { label: 'Top', value: 'Oak veneer, 18 mm' },
      { label: 'Diameter', value: '600 mm' },
      { label: 'Height', value: '420 mm' },
      { label: 'Warranty', value: '2 years' },
    ],
    fabrics: [
      { name: 'Oak', tone: '#c2a878' },
      { name: 'Walnut', tone: '#6b4a33' },
    ],
    weightKg: 9.5,
    dims: '600 × 600 × 420',
    unitsPerCarton: 3,
    leadTime: '5–8 working days',
    origin: 'China',
    incoterm: 'DDP Dubai',
    hsCode: '9403.60',
    minOrder: 3,
  },
  {
    sku: 'CH-700',
    supplierArticle: 'AK-C700',
    name: 'Cantilever meeting chair, black mesh',
    category: 'chairs',
    source: 'Partner',
    partnerId: 's6',
    partnerName: 'Aoke Space Trading L.L.C',
    color: 'Black',
    base: 'Chrome',
    stock: 95,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 285,
    discount: 20,
    cost: 228,
    sale: 319,
    image:
      'https://readdy.ai/api/search-image?query=Black%20cantilever%20meeting%20chair%20with%20mesh%20back%20and%20chrome%20sled%20frame%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20furniture%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-chair-ch700&orientation=squarish',
    options: [
      { label: 'Chrome sled', surcharge: 0 },
      { label: 'Black sled', surcharge: 0 },
      { label: 'Writing tablet', surcharge: 48 },
    ],
    packing: '2 pcs / carton',
    cbm: 0.18,
    stockGroup: 'DIP-CANT-A',
    published: true,
    specialOffer: false,
    description:
      'Cantilever meeting chair with chrome sled base and mesh back. Exclusive to Aoke Space in the Treejar network.',
    specs: [
      { label: 'Back', value: 'Black mesh, low back' },
      { label: 'Frame', value: 'Chrome cantilever tube' },
      { label: 'Stacking', value: 'Up to 8 units' },
      { label: 'Load rating', value: '120 kg' },
      { label: 'Warranty', value: '3 years' },
    ],
    fabrics: [
      { name: 'Black mesh', tone: '#2b2b2b' },
      { name: 'Grey mesh', tone: '#8b9096' },
    ],
    weightKg: 11.2,
    dims: '620 × 580 × 860',
    unitsPerCarton: 2,
    leadTime: '7–10 working days',
    origin: 'China',
    incoterm: 'CIF Jebel Ali',
    hsCode: '9401.30',
    minOrder: 6,
  },
  {
    sku: 'TB-120',
    supplierArticle: 'AK-TB120',
    name: 'Table base 120 cm, Aoke, black',
    category: 'components',
    source: 'Partner',
    partnerId: 's6',
    partnerName: 'Aoke Space Trading L.L.C',
    color: 'Black',
    base: 'Steel',
    stock: 58,
    incomingQty: 0,
    incomingEta: '',
    partnerPrice: 165,
    discount: 20,
    cost: 132,
    sale: 185,
    image:
      'https://readdy.ai/api/search-image?query=Black%20steel%20table%20base%20120%20cm%20with%20two%20column%20legs%20and%20levelling%20feet%2C%20product%20photography%20on%20seamless%20warm%20light%20grey%20studio%20background%2C%20soft%20diffused%20studio%20lighting%2C%20three%20quarter%20view%2C%20no%20props%2C%20editorial%20catalog%20style%2C%20high%20detail&width=900&height=900&seq=treejar-base-tb120&orientation=squarish',
    options: [
      { label: 'Black', surcharge: 0 },
      { label: 'White', surcharge: 0 },
    ],
    packing: '1 set / carton',
    cbm: 0.05,
    stockGroup: 'DIP-BASE-A',
    published: true,
    specialOffer: false,
    description: 'Two-column table base used with partner tops to build meeting tables at short notice.',
    specs: [
      { label: 'Height', value: '720 mm' },
      { label: 'Columns', value: '2 × 80 × 80 mm steel' },
      { label: 'Finish', value: 'Powder coated, matte' },
      { label: 'Warranty', value: '5 years' },
    ],
    fabrics: [
      { name: 'Black', tone: '#2b2b2b' },
      { name: 'White', tone: '#e8e8e4' },
    ],
    weightKg: 5.4,
    dims: '1200 × 700 × 720',
    unitsPerCarton: 1,
    leadTime: '7–10 working days',
    origin: 'China',
    incoterm: 'CIF Jebel Ali',
    hsCode: '7308.90',
    minOrder: 5,
  },
];